import { useRef, createRef } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import {FaCircleNotch} from "react-icons/fa";


export default function LoadingFade({
                                        loading,
                                        stateKey = "content",
                                        timeout = 300,
                                        loader = <div className="h-100 py-5 d-flex justify-content-center align-items-center"><FaCircleNotch size="50" className="fa-spin loading_spinner" /></div>,
                                        classNames = "fade-step",
                                        children,
                                    }) {
    const refs = useRef({});
    const key = loading ? "loading" : String(stateKey);
    if (!refs.current[key]) refs.current[key] = createRef();
    return (
        <SwitchTransition mode="out-in">
            <CSSTransition
                key={key}
                nodeRef={refs.current[key]}
                classNames={classNames}
                timeout={timeout}
                unmountOnExit
                appear
            >
                <div ref={refs.current[key]} className={""}>
                    {loading ? loader : children}
                </div>
            </CSSTransition>
        </SwitchTransition>
    );
}
